/**
 * 單據幣別顯示。只讀後端頂層 currencyCode／exchangeRate，不查主檔、不補 TWD。
 * exchangeRate 單位：1 單位單據幣別 = 多少 TWD。
 */
export function formatDocumentCurrencyLabel(source) {
  const code = source?.currencyCode;
  if (code == null || String(code).trim() === '') {
    return '—';
  }
  if (source.exchangeRate == null || source.exchangeRate === '') {
    return `${code} · 未設定`;
  }
  return `${code} · ${source.exchangeRate}`;
}
